// /schedules/show 전용 헬퍼 (route-local 도메인 지식).
// joinParts / S3_BASE / getAttachedUrls 는 components/detail 로 이관됨 — 여기서 re-export만.

import type { IScheduleDetail } from "../interfaces";

export { joinParts } from "components/detail";
export { S3_BASE } from "components/detail";
export { getAttachedUrls as getAttachmentUrls } from "components/detail";

export interface AggregateRow {
  label: string;
  estimated: unknown;
  final: unknown;
}

// 방문 결과 집계 — 예상 대비 최종 확정 인원.
// Partial<IScheduleDetail>로 받아 필드명 오타가 컴파일 타임에 잡히게 한다.
export const scheduleAggregates = (
  record?: Partial<IScheduleDetail>
): AggregateRow[] => [
  { label: "신규 아동", estimated: record?.newChildrenEstimated, final: record?.newChildrenFinal },
  { label: "변경 아동", estimated: record?.modChildrenEstimated, final: record?.modChildrenFinal },
  { label: "신규 치매", estimated: record?.newDementiaEstimated, final: record?.newDementiaFinal },
  { label: "변경 치매", estimated: record?.modDementiaEstimated, final: record?.modDementiaFinal },
  { label: "신규 지적", estimated: record?.newIdisabledEstimated, final: record?.newIdisabledFinal },
  { label: "변경 지적", estimated: record?.modIdisabledEstimated, final: record?.modIdisabledFinal },
];
